import { render, staticRenderFns } from "./faq-categories.vue?vue&type=template&id=2f8c7512&scoped=true&"
import script from "./faq-categories.vue?vue&type=script&lang=js&"
export * from "./faq-categories.vue?vue&type=script&lang=js&"
import style0 from "./faq-categories.vue?vue&type=style&index=0&id=2f8c7512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c7512",
  null
  
)

export default component.exports